/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type CreateEvaluationRunPathParams = NonNullable<operations['createEvaluationRun']['parameters']['path']>;

export type CreateEvaluationRunRequestBody = OperationRequestBodyContent<operations['createEvaluationRun']>;

export interface Input extends CreateEvaluationRunPathParams {
  apiVersion?: string;
  body: CreateEvaluationRunRequestBody;
}

export async function createEvaluationRun(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projKey}/evaluations/{evaluationId}/runs', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
